// extracted by mini-css-extract-plugin
export default {"form":"FaultRuleForm_form__YYhtT","form__radio":"FaultRuleForm_form__radio__GCUWs","form__buttons":"FaultRuleForm_form__buttons__fdEAm"};